import { API_BASE_URL } from './config';

export interface AdminStats {
  todayBookings: number;
  weekBookings: number;
  monthBookings: number;
  totalPatients: number;
  totalDoctors: number;
  totalServices: number;
  totalPackages: number;
  pendingBookings: number;
  unreadMessages: number;
  revenueThisMonth: number;
  revenueLastMonth: number;
  revenueGrowth: number;
  visitorsToday: number;
  visitorsGrowth: number;
  satisfactionRate: number;
  avgSessionMin: number;
  newPatientsThisMonth: number;
  returningPatients: number;
  cancelledBookings: number;
  completedBookings: number;
}

export interface RecentBooking {
  id: string;
  patientName: string;
  service: string;
  doctor: string;
  date: string;
  time: string;
  status: string;
  phone: string;
  avatar: string;
}

export interface RecentMessage {
  id: string;
  name: string;
  email: string;
  subject: string;
  message: string;
  date: string;
  time: string;
  isRead: boolean;
  avatar: string;
}

export interface BookingsByMonth {
  month: string;
  bookings: number;
  revenue: number;
}

export interface BookingsByService {
  service: string;
  count: number;
  color: string;
}

export interface VisitorsByDay {
  day: string;
  visitors: number;
}

export interface RevenueByMonth {
  month: string;
  revenue: number;
}

export interface ChartData {
  bookingsByMonth: BookingsByMonth[];
  bookingsByService: BookingsByService[];
  visitorsByDay: VisitorsByDay[];
  revenueByMonth: RevenueByMonth[];
}

export interface TopDoctor {
  id: string;
  name: string;
  specialty: string;
  bookings: number;
  rating: number;
  avatar: string;
  growth: number;
}

export interface TodaySchedule {
  time: string;
  patient: string;
  service: string;
  doctor: string;
  status: string;
}

export interface DashboardData {
  adminStats: AdminStats;
  recentBookings: RecentBooking[];
  recentMessages: RecentMessage[];
  chartData: ChartData;
  topDoctors: TopDoctor[];
  todaySchedule: TodaySchedule[];
}

/**
 * Fetch all admin dashboard statistics and list items.
 * @param token Admin bearer authorization token
 */
export async function getDashboardStats(token: string): Promise<DashboardData> {
  const response = await fetch(`${API_BASE_URL}/admin/dashboard-stats`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.detail || 'فشل في جلب إحصائيات لوحة التحكم من الخادم');
  }

  return response.json();
}
